var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunchReadinessPack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 22C9.5875 22 9.23438 21.8531 8.94063 21.5594C8.64688 21.2656 8.5 20.9125 8.5 20.5V11.5C8.5 11.0875 8.64688 10.7344 8.94063 10.4406C9.23438 10.1469 9.5875 10 10 10H14.5L16 11.5H22C22.4125 11.5 22.7656 11.6469 23.0594 11.9406C23.3531 12.2344 23.5 12.5875 23.5 13V20.5C23.5 20.9125 23.3531 21.2656 23.0594 21.5594C22.7656 21.8531 22.4125 22 22 22H10ZM10 20.5H22V13H15.3813L13.8813 11.5H10V20.5Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchReadinessPack);
export default __webpack_public_path__ + "static/media/LaunchReadinessPack.03b65d88605772c5c7f05025b70ded29.svg";
export { ForwardRef as ReactComponent };